"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = require("@formily/shared");
var pascal_case_1 = __importDefault(require("pascal-case"));
var registry = {
    fields: {},
    virtualFields: {},
    wrappers: [],
    formItemComponent: function (_a) {
        var children = _a.children;
        return children;
    },
    formComponent: 'form',
    previewText: null
};
exports.getRegistry = function () {
    return {
        fields: registry.fields,
        virtualFields: registry.virtualFields,
        formItemComponent: registry.formItemComponent,
        formComponent: registry.formComponent,
        previewText: registry.previewText
    };
};
exports.cleanRegistry = function () {
    registry.fields = {};
    registry.virtualFields = {};
    registry.wrappers = [];
    registry.previewText = null;
};
function registerFormComponent(component) {
    if (shared_1.isFn(component)) {
        registry.formComponent = component;
    }
}
exports.registerFormComponent = registerFormComponent;
function compose(payload, args, revert) {
    return shared_1.reduce(args, function (buf, fn) {
        return shared_1.isFn(fn) ? fn(buf) : buf;
    }, payload, revert);
}
function registerFormField(name, component, noWrapper) {
    if (noWrapper === void 0) { noWrapper = false; }
    if (name &&
        (shared_1.isFn(component) || typeof component.styledComponentId === 'string')) {
        name = shared_1.lowercase(name);
        if (registry.fields[name]) {
            shared_1.log.warn('Component registration naming conflict. Please change the name. Globally registered components will no longer support overlay registration in the future.');
        }
        if (noWrapper) {
            registry.fields[name] = component;
            registry.fields[name].__WRAPPERS__ = [];
        }
        else {
            registry.fields[name] = compose(component, registry.wrappers, true);
            registry.fields[name].__WRAPPERS__ = registry.wrappers;
        }
        registry.fields[name].displayName = pascal_case_1.default(name);
    }
}
exports.registerFormField = registerFormField;
function registerFormFields(object) {
    shared_1.each(object, function (component, key) {
        registerFormField(key, component);
    });
}
exports.registerFormFields = registerFormFields;
function registerVirtualBox(name, component) {
    if (name &&
        (shared_1.isFn(component) || typeof component.styledComponentId === 'string')) {
        name = shared_1.lowercase(name);
        registry.virtualFields[name] = component;
        registry.virtualFields[name].displayName = pascal_case_1.default(name);
    }
}
exports.registerVirtualBox = registerVirtualBox;
function registerFormItemComponent(component) {
    if (shared_1.isFn(component)) {
        registry.formItemComponent = component;
    }
}
exports.registerFormItemComponent = registerFormItemComponent;
exports.registerFieldMiddleware = shared_1.deprecate(function registerFieldMiddleware() {
    var wrappers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        wrappers[_i] = arguments[_i];
    }
    registry.wrappers = registry.wrappers.concat(wrappers);
    shared_1.each(registry.fields, function (component, key) {
        if (!component.__WRAPPERS__.some(function (wrapper) { return wrappers.indexOf(wrapper) > -1; })) {
            registry.fields[key] = compose(registry.fields[key], wrappers, true);
            registry.fields[key].__WRAPPERS__ = wrappers;
        }
    });
});
function registerPreviewTextComponent(component) {
    if (shared_1.isFn(component)) {
        registry.previewText = component;
    }
}
exports.registerPreviewTextComponent = registerPreviewTextComponent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react-schema-renderer/lib/shared/registry.js
// module id = 617
// module chunks = 0